import { lazy, Suspense } from "react";
import { PageSkeleton } from "../customs/skeleton/main";
const Main = lazy(() => import("../components/notification/main"));

const SingleSignOn = () => {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <Main />
    </Suspense>
  );
};

export default SingleSignOn;
